module.exports = __webpack_public_path__ + "img/alien.2faf6405.svg";